
import { browser } from '$app/environment'
import { validUUID } from '$lib/functions/helpers'
import { apiGetJson } from '$lib/proxy/apiProxy'

import { type SubscriptionTableInfo } from './types'



// const store = writable([] as SubscriptionTableInfo[])
// export { store as subscription_table_info_store }
let subscriptionTableId = ''
let subscriptionTableInfo: SubscriptionTableInfo[] = []


let promiseFetch: Promise<SubscriptionTableInfo[]>
let state: 'pending' | 'reading' | 'ready' = 'pending'

const InitSubscriptionTableInfo = async (sub_table_id: string, pFetch = fetch, force = false) => {
	// if SSR just return the promise data
	if (!browser) return fetchData(sub_table_id, pFetch)

	if (sub_table_id==='' || sub_table_id===undefined) {
		subscriptionTableInfo = []
		return true
	}
	
	if (subscriptionTableId !== sub_table_id) {
		force = true
	}

	if (!force && state === 'ready') return
	if (!force && state === 'reading') {
		await promiseFetch
		return true
	}

	promiseFetch = fetchData(sub_table_id, pFetch)
	await promiseFetch
	return true
}

const fetchData = async (sub_table_id: string, pFetch = fetch) => {
	if (browser) state = 'reading'

	if (!validUUID(sub_table_id)) {
		if (browser) state = 'pending'
		return []
	}

	const params = { sub_table_id: sub_table_id }	
	// const body = JSON.stringify(params)
	// const jsonData = await apiFetchJson(pFetch, 'get', 
	// 	'/subscription/table_info', undefined, body)
	const jsonData = await apiGetJson('/subscription/table_info', params )
	if (!jsonData || jsonData.error) {
		if (browser) state = 'pending'
		return []
	}


	// const data = parseServer(jsonData)
	const data = jsonData
	if (browser) {
		subscriptionTableId = sub_table_id
		subscriptionTableInfo = data
		// store.set(data)
		state = 'ready'
	}

	return data
}


export async function getSubscriptionTableInfo(sub_table_id: string) {

	if (!validUUID(sub_table_id)) {
		// throw error(404)
		return []
	}	

	if (subscriptionTableId === sub_table_id) return subscriptionTableInfo

	await InitSubscriptionTableInfo(sub_table_id)
	return subscriptionTableInfo

}

export async function getSubscriptionTableIdActive() {
	const jsonData = await apiGetJson('/subscription/table_id_active')
	if (jsonData?.error) {
		throw new Error(jsonData.error.message)
	}

	const subscribeTableId = jsonData
	InitSubscriptionTableInfo(subscribeTableId)
	return subscribeTableId
}